<template lang="html">
  <div class="sign-in">
    <div class="sign-in-text">坚持学习签到才能收获知识！</div>
    <ui-button
      v-if="isSigned"
      height="60"
      width="160"
      font-size="30"
      shadow
      round
      inline-block
      @click.native="click">签到</ui-button>
    <div class="sign-in-button-disable"
      v-else>已签到</div>
  </div>
</template>

<script>
import UiButton from './UI/Button.vue'

export default {
  name: 'SignIn',

  props: {
    isSigned: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    click () {
      this.$emit('click')
    }
  },

  components: {
    UiButton
  }
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../style/main";

.sign-in {
  border-top: use(18) solid #F2F2F2;
  height: use(236);
  text-align: center;
  &-text {
    margin-top: use(60);
    font-size: use(28);
    color: #999999;
    margin-bottom: use(28);
  }

  &-button-disable {
    margin: 0 auto;
    width: rem(160);
    height: rem(60);
    line-height: rem(60);
    border-radius: rem(30);
    background-color: #bfbfbf;
    color: #fff;
  }
}
</style>
